const config = {
    API_URL: process.env.VUE_APP_API_URL,
    env: process.env.NODE_ENV
}

export default config